module.exports = __webpack_public_path__ + "assets/img/处理完成.3211ba8b.svg";